export default {"src":"/_next/static/media/lacks-privacy.12a2602a.svg","height":30,"width":20,"blurWidth":0,"blurHeight":0};